import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import {
  cancelOrder,
  confirmOrder,
  deleteOrder,
  deliveredOrder,
  getOrders,
  shipOrder,
} from "../../../Redux/Admin/Orders/Action";

const OrdersTable = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ status: "", sort: "" });
  const [anchorElArray, setAnchorElArray] = useState([]);
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { adminsOrder } = useSelector((store) => store);
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    dispatch(getOrders({ jwt }));
  }, [jwt]);

  // Sorting and filtering orders
  useEffect(() => {
    console.log("allorders",adminsOrder)
    let sortedOrders = [...(adminsOrder?.orders.data || [])];

    // Filter based on status
    if (formData.status) {
      sortedOrders = sortedOrders.filter(
        (order) => order.orderStatus === formData.status
      );
    }

    if (formData.sort === "Newest") {
      sortedOrders.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    } else if (formData.sort === "Older") {
      sortedOrders.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );
    }

    setFilteredOrders(sortedOrders);
  }, [formData, adminsOrder.orders]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleUpdateStatusMenuClick = (event, index) => {
    const newAnchorElArray = [...anchorElArray];
    newAnchorElArray[index] = event.currentTarget;
    setAnchorElArray(newAnchorElArray);
  };

  const handleUpdateStatusMenuClose = (index) => {
    const newAnchorElArray = [...anchorElArray];
    newAnchorElArray[index] = null;
    setAnchorElArray(newAnchorElArray);
  };

  const handleConfirmedOrder = (orderId, index) => {
    handleUpdateStatusMenuClose(index);
    dispatch(confirmOrder(orderId));
  };

  const handleShippedOrder = (orderId, index) => {
    handleUpdateStatusMenuClose(index);
    dispatch(shipOrder(orderId));
  };

  const handleDeliveredOrder = (orderId, index) => {
    handleUpdateStatusMenuClose(index);
    dispatch(deliveredOrder(orderId));
  };

  const handleCancelOrder = (orderId, index) => {
    handleUpdateStatusMenuClose(index);
    dispatch(cancelOrder(orderId));
  };

  const handleDeleteOrder = (orderId) => {
    dispatch(deleteOrder(orderId));
  };

  // Helper function to check if an order can be updated
  const isStatusUpdatable = (status) => {
    return status !== "DELIVERED" && status !== "CANCELLED";
  };

  return (
    <Box>
      <Card className="p-3">
        <CardHeader title="Sort" />
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel>Status</InputLabel>
              <Select
                value={formData.status}
                onChange={handleChange}
                name="status"
              >
                <MenuItem value="PENDING">PENDING</MenuItem>
                <MenuItem value="CONFIRMED">CONFIRMED</MenuItem>
                <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                <MenuItem value="CANCELLED">CANCELLED</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth>
              <InputLabel>Sort By</InputLabel>
              <Select
                value={formData.sort}
                onChange={handleChange}
                name="sort"
              >
                <MenuItem value="Newest">Newest</MenuItem>
                <MenuItem value="Older">Older</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Card>

      <Card className="mt-2">
        <CardHeader title="All Orders" />
        <TableContainer>
          <Table aria-label="table in dashboard">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Id</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Status</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Update</TableCell>
                <TableCell sx={{ textAlign: "center" }}>Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.map((item, index) => (
                <TableRow hover key={item._id}>
                  <TableCell>
                    <AvatarGroup max={4}>
                      {item.orderItems.map((orderItem) => (
                        <Avatar
                          key={orderItem.product?._id}
                          alt={orderItem.product?.title}
                          src={orderItem.product?.imageUrl}
                        />
                      ))}
                    </AvatarGroup>
                  </TableCell>
                  {/* <Link to={`/admin/orderDetail/${item._id}`} style={{ textDecoration: 'none', color: 'inherit' }}> */}

                  <TableCell>
                    <Box>
                      <Typography fontWeight={500}>
                        {item.orderItems.map((order) => (
                          <span key={order.product?._id}> {order.product?.title},</span>
                        ))}
                      </Typography>
                      <Typography variant="caption">
                        {item.orderItems.map((order) => (
                          <span key={order.product?._id} className="opacity-60">
                            {" "}
                            {order.product?.brand},
                          </span>
                        ))}
                      </Typography>
                    </Box>
                  </TableCell>

                  {/* </Link> */}
                  <TableCell>{item.totalPrice}</TableCell>
                  <TableCell>{item._id}</TableCell>
                  <TableCell>
                    <Chip
                      label={item.orderStatus}
                      size="small"
                      color={
                        item.orderStatus === "PENDING"
                          ? "info"
                          : item.orderStatus === "DELIVERED"
                          ? "success"
                          : "secondary"
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      onClick={(event) =>
                        handleUpdateStatusMenuClick(event, index)
                      }
                      disabled={!isStatusUpdatable(item.orderStatus)} // Disable if the order is delivered or cancelled
                    >
                      Status
                    </Button>
                    <Menu
                      anchorEl={anchorElArray[index]}
                      open={Boolean(anchorElArray[index])}
                      onClose={() => handleUpdateStatusMenuClose(index)}
                    >
                      {/* Only show status options that are valid for the current status */}
                      {isStatusUpdatable(item.orderStatus) && (
                        <>
                          {item.orderStatus !== "CONFIRMED" && (
                            <MenuItem onClick={() => handleConfirmedOrder(item._id, index)}>
                              Confirmed
                            </MenuItem>
                          )}
                          {item.orderStatus !== "SHIPPED" && (
                            <MenuItem onClick={() => handleShippedOrder(item._id, index)}>
                              Shipped
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => handleDeliveredOrder(item._id, index)}>
                            Delivered
                          </MenuItem>
                          <MenuItem onClick={() => handleCancelOrder(item._id, index)}>
                            Cancel
                          </MenuItem>
                        </>
                      )}
                    </Menu>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() => handleDeleteOrder(item._id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ my: 1, display: "flex", justifyContent: "center" }}>
          <Pagination count={10} page={1} color="primary" />
        </Box>
      </Card>
    </Box>
  );
};

export default OrdersTable;
